

export const TRACKS = [
    {
        name: "self-assessment",
        title: "Self-Assessment",
        points: [
            "This is just for you and your organisation. No need to upload evidence - you’ve nothing to prove!",
            "The self-assessment version asks all the same questions as full verification, and will give you the same score and next steps to improve, but your score will be unverified",
            "This is a safe environment for you to understand where you are currently and what you might be able to do to progress on your sustainability journey.",
            "You can do this rapidly in as little as 20 minutes, or more thoroughly with some colleagues over an hour.",
            "Happy scoring!",
        ]
        , price: "FREE"
    },
    {
        name: "validation",
        title: "Verification track",
        points: [
            "If you want to verify your score, you’ll be asked to upload evidence to demonstrate the answers you have selected.",
            "Once you’ve uploaded your evidence and you’re ready to submit, you’ll pay your verification fee which is dependent on your organisation size.",
            "Your verifier will be assigned within 5 working days, and will be in touch with any questions or additional evidence requests to justify your score.",
            "Once verified, you’ll receive a notification of the final score, and your scores will be passed to Legacy Media to be made available through their ESG reporting platforms.",
        ]
        , price: "from £1000 ex VAT"
    }]